// extracted by mini-css-extract-plugin
export default {"root":"InlineSelect_root_g6pxm","select":"InlineSelect_select_Byeje","arrow":"InlineSelect_arrow_AA2Gi"};